import { __assign } from "tslib";
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { UserAvatar } from './user-avatar';
export var createUserAvatarLegacyDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.user-avatar', UserAvatar.name);
    return {
        getInitials: function () { return baseDriver.find('.inner').getText(); },
        isProfileImgVisible: function () { return baseDriver.isChildVisible('img'); },
        isInitialsVisible: function () { return baseDriver.isChildVisible('.initials'); },
        isStatusVisible: function () { return baseDriver.isChildVisible('.status-indicator'); },
        isUserBadgeVisible: function () { return baseDriver.isChildVisible('.user-badge'); },
        isPartnerBadgeVisible: function () { return baseDriver.isChildVisible('.partner-badge'); },
        getProfileImgUrl: function () { return baseDriver.find('img').getAttribute('src') || ''; }
    };
};
export var createUserAvatar = function (props, children) {
    var element = renderAndMountComponent(React.createElement(UserAvatar, __assign({}, props), children));
    return createUserAvatarLegacyDriver(element);
};
//# sourceMappingURL=user-avatar.legacy-driver.js.map